// src/api/axiosInstance.js
import axios from "axios";

// Create a reusable axios instance
const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	timeout: 10000, // optional
	
});

// Request interceptor to attach token automatically
api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor to handle 401 (session expired) globally
api.interceptors.response.use(
	(response) => response,
	(error) => {
		const isLoginRequest = error.config?.url?.includes("/auth/login");
		if (error.response?.status === 401 && !isLoginRequest) {
			localStorage.removeItem("token");
			window.location.href = "/"; // or dispatch logout + redirect
			// Optional: show toast once here instead of in every action
		}
		return Promise.reject(error);
	}
);

export default api;